import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/cheap-storage-places.jpg'),
    alt: 'cheap storage places page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'cheap storage places page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Find <span>Cheap Storage</span><span>Places Near You</span>',
  description:
    'Find affordable storage without compromising security. Perfect for moving, decluttering, or seasonal items, keeping your belongings safe on a budget.',
  image: {
    url: '/images/v2/pages/landing-pages/cheap-storage-places/hero-image.jpg',
    alt: 'Find Cheap Storage Places Near You'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Cheap Storage Places' }
}

export const ourProcessSectionContent = {
  title: 'How Cheap Storage Places Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/cheap-storage-places/how-cheap-storage-places-work.png',
    alt: 'How Cheap Storage Places Work'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Booking and Scheduling',
      description:
        'Select your preferred storage unit, duration, and location with our simple online booking system, making the process quick and hassle-free.',
      image: {
        src: '/images/v2/pages/landing-pages/cheap-storage-places/easy-booking-sand-scheduling.png',
        alt: 'Easy Booking and Scheduling'
      }
    },
    {
      id: 2,
      title: 'Secure Storage Solutions',
      description:
        'Our affordable storage units come with high-level security features, including 24/7 surveillance, so you can store your items with peace of mind.',
      image: {
        src: '/images/v2/pages/landing-pages/cheap-storage-places/secure-storage-solutions.png',
        alt: 'Secure Storage Solutions'
      }
    },
    {
      id: 3,
      title: 'Convenient Access',
      description:
        'Access your stored items whenever needed, with extended hours and flexible options to suit your schedule.',
      image: {
        src: '/images/v2/pages/landing-pages/cheap-storage-places/convenient-access.png',
        alt: 'Convenient Access'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Cheap Storage Places for Your Needs',
  description:
    'At ShipAndStorage, we provide budget-friendly storage solutions that ensure your belongings are secure and accessible without the high costs of traditional storage options. Our cheap storage places offer peace of mind while keeping your costs low.',
  image: {
    src: '/images/v2/pages/landing-pages/cheap-storage-places/cheap-storage-places-for-your-needs.jpg',
    alt: 'Cheap Storage Places for Your Needs'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Choosing Cheap Storage Places',

  cards: [
    {
      id: 1,
      title: 'Cost-Effective Pricing',
      description:
        'We offer some of the lowest prices in the industry, ensuring that your storage needs are met without breaking your budget.',
      image: {
        src: '/images/v2/pages/landing-pages/cheap-storage-places/cost-effective-pricing.png',
        alt: 'Cost-Effective Pricing'
      }
    },
    {
      id: 2,
      title: 'No Hidden Fees',
      description: 'What you see is what you get - our pricing is clear, with no hidden fees or unexpected charges.',
      image: {
        src: '/images/v2/pages/landing-pages/cheap-storage-places/no-hidden-fees.png',
        alt: 'No Hidden Fees'
      }
    },
    {
      id: 3,
      title: 'Flexible Storage Terms',
      description:
        'Choose the length of time you need to store your items, from short-term to long-term, with flexible plans to suit your needs.',
      image: {
        src: '/images/v2/pages/landing-pages/cheap-storage-places/flexible-storage-terms.png',
        alt: 'Flexible Storage Terms'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Cheap Storage Places?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Students',
          description:
            'Store your belongings affordably during summer breaks or while transitioning between housing options.'
        },
        {
          id: 2,
          title: 'Homeowners or Renters',
          description:
            "If you're moving or renovating, our cheap storage places provide a cost-effective solution for your household items."
        },
        {
          id: 3,
          title: 'Small Business Owners',
          description:
            'Store inventory, equipment, or supplies at affordable rates, keeping your business organized and clutter-free.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/cheap-storage-places/who-should-choose-cheap-storage-places.jpg',
        alt: 'Who Should Choose Cheap Storage Places?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Explore Our Additional Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solutions',
      description:
        'Affordable storage for business owners, perfect for storing inventory, equipment, or documents securely and cost-effectively.',
      image: {
        src: '/images/v2/pages/landing-pages/cheap-storage-places/business-storage-solution.png',
        alt: 'Business Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Whether you’re moving homes or downsizing, we offer cheap storage places to help keep your items safe and organized.',
      image: {
        src: '/images/v2/pages/landing-pages/cheap-storage-places/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description: 'Ship your luggage or boxes locally and internationally with affordable rates and reliable service.',
      image: {
        src: '/images/v2/pages/landing-pages/cheap-storage-places/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Box Storage' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description:
        'Perfect for homeowners undergoing renovations or going on vacation, our residential storage options are both affordable and secure.',
      image: {
        src: '/images/v2/pages/landing-pages/cheap-storage-places/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Cheap Storage Places?',

  image: {
    url: '/images/v2/pages/landing-pages/cheap-storage-places/why-choose-shipandstorage-for-cheap-storage-places.jpg',
    alt: 'Why Choose ShipAndStorage for Cheap Storage Places?'
  },

  articles: [
    {
      id: 1,
      title: 'Affordable Prices',
      description:
        'We provide cheap storage places with no compromise on security, offering the most cost-effective options in the market.'
    },
    {
      id: 2,
      title: 'Flexible Storage Plans',
      description: 'We offer a variety of storage unit sizes and flexible rental terms to meet your specific needs.'
    },
    {
      id: 3,
      title: 'Clear and Transparent Pricing',
      description:
        'Enjoy peace of mind with our transparent pricing structure, designed to fit any budget without hidden fees.'
    },
    {
      id: 4,
      title: 'Convenient Locations',
      description:
        'Our cheap storage places are located nationwide, making it easy for you to find a location near you.'
    },
    {
      id: 5,
      title: 'Safe and Secure Facilities',
      description:
        'Your belongings are stored securely with round-the-clock monitoring and access control, keeping them safe at all times.'
    },
    {
      id: 6,
      title: 'Fast and Reliable Service',
      description:
        'Get the help you need quickly and efficiently, with a smooth process from booking to accessing your items.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Find Cheap Storage  Places Near You Today',
  description:
    'Find cheap storage places near you today. Affordable and secure solutions for storing your items at convenient locations.',
  image: {
    src: '/images/v2/pages/landing-pages/cheap-storage-places/find-cheap-storage-places-near-you-today.png',
    alt: 'Find Cheap Storage  Places Near You Today'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Book Your Cheap Storage Today' }
}

export const ourPartnersSectionContent = {
  title: 'Our Shipping Partners',
  description:
    'ShipAndStorage partners with trusted shipping and logistics providers to ensure your items are handled with care and delivered safely.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx ensures secure and reliable storage solutions, with global shipping capabilities to deliver your items safely.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL provides secure storage options and fast, reliable shipping services, ensuring your items are delivered and stored safely.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS offers top-quality storage solutions and secure delivery services, ensuring your items are safely handled and stored.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
